<template>
  <v-app-bar app color="#990000" class="header-bar" ref="" :height="this.header_height">
    <div style="display:flex; flex-direction: column; width:100% ">
      <div style="display:flex; flex-direction: row; justify-content: space-around; position: absolute; top: 5px; width:100%">
        <v-toolbar-title class="headline" style="padding-top:10px">
        <div id="name-container">
          <a class="link" href="/">
            <span id="name">Maja J Matari&#263;</span>
          </a>
          <button @click="readName()" class="pronounce">
            <img src="../../assets/bullhorn.svg" class="bullhorn"/>
            <span class="full_word">How to pronounce my name</span>
            <span class="cut_word">Pronunciation</span>
          </button>
        </div>
        <div id="titles">
          <span v-html="this.titles"></span>
        </div>
        </v-toolbar-title>
<!--        <v-spacer></v-spacer>-->
        <Menu style="position: relative; top:10px;"/>
        <i class="mdi mdi-menu mobile-dropdown-menu" @click="openMobileMenu" />
      </div>
<!--    <div id="titles">-->
<!--      <span v-html="this.titles"></span>-->
<!--    </div>-->
    </div>
  </v-app-bar>
</template>

<script>
import Menu from "./Menu";
import {getHeaderInfo} from "@/service/header/header";

export default {
  components: {
    Menu,
  },
  data() {
    return {
      audio_src:"",
      titles:"",
      header_height: 110,
      screenWidth: document.body.offsetWidth
    };
  },
  watch:{
    screenWidth(val){
      if(!this.timer){
        this.screenWidth = val
        if(this.screenWidth <= 1300){
          this.header_height = 64
        } else {
          this.header_height = 110
        }
        this.timer = true
        let that = this
        setTimeout(function(){
          that.timer = false
        },300)
      }
    }
  },
  mounted(){
    getHeaderInfo()
        .then(header => {
          this.audio_src = header.audio_src;
          this.titles = header.titles;
        })
        .catch(err => {
          console.error(err.message);
        });
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    openMobileMenu() {
      this.$store.commit("sidebar", true);
    },
    readName(){
      console.log("read")
      var audio = new Audio(this.audio_src);
      audio.play();
    },
  },
};
</script>

<style lang="scss">
.header-bar {
  max-width: 100vw;

  #name-container{
    z-index:99;
    overflow:visible;
    position:relative;
    display:flex;
    padding-left:4%;
    //justify-content: center;
    vertical-align: center;
  }

  #name {
    //padding-left: px;
    text-decoration: none;
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 36px;
    color: #ffffff;
    //position: relative;
    letter-spacing: 1px;
  }



  #titles {
    position: absolute;
    width:100%;
    padding-left:20px;
    line-height:1.4;
    font-family: 'Open Sans', sans-serif;
    font-size: 13px;
    letter-spacing: 0.5px;
    color: #d3d8cd;
  }

  #titles a {
    text-decoration: none;
    color: #d3d8cd;
    font-weight: 900;
  }
  #titles a:hover,
  #titles a:focus {
    color: rgb(255,204,0);
    text-decoration: none;
  }

  .pronounce{
    margin-left: 5px;
    font-size: 13px;
    /*width:200px;*/
    color:white;

    border: 0px;
    border-radius: 7px;
    background-color: rgb(153,0,0);
  }

  .bullhorn{
    /*width:20px;*/
    height:15px;
    color:"white";
    fill:"white";
  }

  .pronounce:hover{
    background-color: rgba(180,57,57,0.3);
    color:#EAEAEA;
  }

  .mobile-dropdown-menu {
    display: none;
  }
}

/**
 * following are responsive support
 */
@media (max-width: 1100px) {
  .header-bar {

    #name-container{
      vertical-align: center;
      font-size: 30px;
      margin-top:10px;
    }

    .mobile-dropdown-menu {
      display: block;
      color: white;
      font-size: 40px;
      position: relative;
      top: -2px;
    }
  }
}

//@media (min-width: 1300px){
//  v-app-bar {
//    height:110px
//  }
//}

@media (max-width: 1300px) {
  #titles {
    display: none!important;
  }

  #name{
    vertical-align: center;
  }

}

@media (max-width:1300px){
  .pronounce{
    width:120px;
  }
  .full_word{
    display:none;
  }
}

@media (min-width:1301px){
  .pronounce{
    width:200px;
  }
  .cut_word{
    display:none;
  }
}
</style>
